export function withStateUpdates<T extends object>(state: T) {
  return (...args: Array<(state: T) => T>): T => args.reduce((acc, updateAction) => updateAction(acc), state)
}
